import { render, staticRenderFns } from "./Sns.vue?vue&type=template&id=b4b66156&scoped=true"
import script from "./Sns.vue?vue&type=script&lang=js"
export * from "./Sns.vue?vue&type=script&lang=js"
import style0 from "./Sns.vue?vue&type=style&index=0&id=b4b66156&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4b66156",
  null
  
)

export default component.exports